import React from "react";
import { array } from "prop-types";
import { useSelector } from "react-redux";
import get from "lodash/get";

import RelatedStories from "./related-stories";
import { DfpComponent } from "../../../ads/dfp-component";
// import Newsletter from "./newsletter";

import "./related-stories-block.m.css";

const RelatedStoriesBlock = ({ relatedStories }) => {
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], ""));
  const adSlots = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots"], {}));

  return (
    <div styleName="wrapper" className="related-stories-wrapper">
      {pageType === "search-page" ? (
        <div styleName="placeholder" />
      ) : (
        <DfpComponent
          adStyleName="ad-slot-size-300x220"
          className="first-ad"
          id={`${pageType}-rel-first-ad`}
          path={adSlots.related_str_ad1.ad_unit}
          size={adSlots.related_str_ad1.sizes}
          viewPortSizeMapping={adSlots.related_str_ad1.view_port_size_mapping}
        />
      )}
      <DfpComponent
        adStyleName="ad-slot-size-300x220"
        className="second-ad"
        id={`${pageType}-rel-second-ad`}
        path={adSlots.related_str_ad2.ad_unit}
        size={adSlots.related_str_ad2.sizes}
        viewPortSizeMapping={adSlots.related_str_ad2.view_port_size_mapping}
      />
      <RelatedStories relatedStories={relatedStories} />
      {/* <Newsletter /> */}
      <DfpComponent
        adStyleName="ad-slot-size-300x220"
        className="first-ad"
        id={`${pageType}-rel-third-ad`}
        path={adSlots.related_str_ad3.ad_unit}
        size={adSlots.related_str_ad3.sizes}
        viewPortSizeMapping={adSlots.related_str_ad3.view_port_size_mapping}
      />
      <DfpComponent
        adStyleName="ad-slot-size-300x220"
        className="second-ad"
        id={`${pageType}-rel-fourth-ad`}
        path={adSlots.related_str_ad4.ad_unit}
        size={adSlots.related_str_ad4.sizes}
        viewPortSizeMapping={adSlots.related_str_ad4.view_port_size_mapping}
      />
    </div>
  );
};

RelatedStoriesBlock.propTypes = {
  relatedStories: array,
};

export default RelatedStoriesBlock;
